// src/oura/requests/flag.ts
//
// Client requests are live on the change-requests API. Production keeps the
// page and its rail item hidden until the rollout flag ships (ticket #4579).

import { isOuraProd } from "../role";

// Production turns it on with VITE_ENABLE_OURA_REQUESTS_LIVE=true (#4579); absent, dev and staging only.
export const REQUESTS_ON: boolean = import.meta.env.VITE_ENABLE_OURA_REQUESTS_LIVE === "true" || !isOuraProd();
